import { create } from 'zustand';
import { FiltersCollection } from '@libs/store/filters';
import { TemplateListItem } from '@libs/models/shiftTemplates';
import { fetchShiftTemplatesList } from '@libs/api/shiftTemplates/list';

type InitialState = {
  initialized: boolean;
  loading: boolean;
  list: TemplateListItem[];
  load: (filters: FiltersCollection) => Promise<void>;
  deinit: () => void;
};

export const useShiftTemplatesList = create<InitialState>()((set) => ({
  initialized: false,
  loading: false,
  list: [],
  load: async (filters) => {
    set({ loading: true });
    try {
      const resp = await fetchShiftTemplatesList({ filters });
      const { items } = resp;
      set({
        loading: false,
        list: items,
        initialized: true,
      });
    } finally {
      set({ loading: false, initialized: true });
    }
  },
  deinit: () => set({ initialized: false, loading: false, list: [] }),
}));
